import { loadScript } from './feishu-sdk';

export const FEISHU_H5_SDK_URL = 'https://lf-scm-cn.feishucdn.com/lark/op/h5-js-sdk-1.5.44.js';

export const getFeishuAppId = () => process.env.VITE_FEISHU_APP_ID;

export const loadFeishuH5Sdk = (targetDocument = document) =>
  loadScript(FEISHU_H5_SDK_URL, targetDocument);

export const isFeishuClientUserAgent = (userAgent = '') => /Feishu|Lark/i.test(userAgent);

export const isFeishuClient = (targetWindow = window) =>
  isFeishuClientUserAgent(targetWindow?.navigator?.userAgent);

export const waitFeishuH5SdkReady = (targetWindow = window) =>
  new Promise((resolve, reject) => {
    if (!targetWindow?.h5sdk?.ready) {
      reject(new Error('当前环境不支持飞书免密登录'));
      return;
    }
    targetWindow.h5sdk.ready(() => resolve());
  });

const getCodeFromRequestAuthCode = ({ appID, targetWindow }) =>
  new Promise((resolve, reject) => {
    if (!targetWindow?.tt?.requestAuthCode) {
      reject(new Error('当前环境不支持飞书免密登录'));
      return;
    }

    targetWindow.tt.requestAuthCode({
      appId: appID,
      success: (result) => {
        const code = result?.code;
        if (!code) {
          reject(new Error('飞书未返回登录授权码'));
          return;
        }
        resolve(code);
      },
      fail: (error) => {
        reject(
          new Error(error?.errMsg || error?.errString || error?.message || '飞书免密授权失败'),
        );
      },
    });
  });

const resolveFeishuJssdkErrorMessage = (error, fallback = '飞书免密授权失败') =>
  error?.errMsg || error?.errString || error?.message || fallback;

export const requestFeishuAccessCode = (targetWindow = window) =>
  new Promise((resolve, reject) => {
    const appID = getFeishuAppId();
    if (!appID) {
      reject(new Error('飞书应用未配置，请联系系统管理员'));
      return;
    }
    if (targetWindow?.tt?.requestAuthCode) {
      getCodeFromRequestAuthCode({ appID, targetWindow }).then(resolve).catch(reject);
      return;
    }
    if (!targetWindow?.tt?.requestAccess) {
      reject(new Error('当前环境不支持飞书免密登录'));
      return;
    }

    targetWindow.tt.requestAccess({
      appID,
      scopeList: [],
      success: (result) => {
        const code = result?.code;
        if (!code) {
          reject(new Error('飞书未返回登录授权码'));
          return;
        }
        resolve(code);
      },
      fail: (error) => {
        reject(new Error(resolveFeishuJssdkErrorMessage(error)));
      },
    });
  });
